import { getContrastingTextColor, primaryColor, secondaryColor } from "../../utils";

const BoardButton = ({
  primary,
  secondary,
  border,
  bg,
  text,
  children,
  onClick,
  className,
  type = "submit",
}) => {
  const color = primary ? primaryColor : secondary ? secondaryColor : "";
  return (
    <button
      onClick={onClick}
      type={type}
      className={`text-white rounded-lg py-2 px-6 text-lg capitalize ${className}`}
      style={{
        color: text ? color : getContrastingTextColor(color),
        backgroundColor: bg ? color : "",
        borderColor: border ? color : "",
      }}
    >
      {children}
    </button>
  );
};

export default BoardButton;
